import { inject, Injectable, OnInit } from '@angular/core';
import { BaseDataSource, RxapDataSource } from 'eurogard-data-source';
import {
  DeviceInboxRegistrationTokenControllerGetTokenByUserUUIDRemoteMethod
} from 'open-api-legacy/remote-methods/device-inbox-registration-token-controller-get-token-by-user-uuid.remote-method';
import {
  DeviceInboxRegistrationTokenControllerGetTokenByUserUUIDResponse
} from 'open-api-legacy/responses/device-inbox-registration-token-controller-get-token-by-user-uuid.response';
import { shareReplay, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
@RxapDataSource('registration-token-form')
export class RegistrationTokenFormDataSource extends BaseDataSource<DeviceInboxRegistrationTokenControllerGetTokenByUserUUIDResponse> implements OnInit {
  private readonly method = inject(DeviceInboxRegistrationTokenControllerGetTokenByUserUUIDRemoteMethod);

  private readonly _refresh$ = new Subject<void>();

  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngOnInit() {
    this._data$ = this._refresh$.pipe(
      switchMap(() => this.method.call()),
      shareReplay(1),
    );
  }

  override refresh() {
    this._refresh$.next();
  }
}
